import {
  MdAccountTree,
  MdApi,
  MdBusinessCenter,
  MdCallMerge,
  MdCallSplit,
  MdDescription,
  MdDraw,
  MdEuro,
  MdHourglassEmpty,
  MdNotifications,
  MdOutlineCancel,
  MdOutlineDescription,
  MdOutlineRule,
  MdPayment,
  MdPercent,
  MdPersonAdd,
  MdRadioButtonChecked,
  MdSend,
  MdTimer,
} from "react-icons/md";
import { COLORS } from "shared/style/colors";
import { NODE_TYPES } from "utils/constants";

export const NODE_TYPE_META = {
  [NODE_TYPES.STATUS]: { icon: MdRadioButtonChecked, color: COLORS.C_PRIMARY },
  [NODE_TYPES.FORM_STEP]: { icon: MdOutlineDescription, color: "#3f51b5" },
  [NODE_TYPES.DECISION]: {
    icon: MdOutlineRule,
    color: COLORS.C_WARNING,
    diamond: true,
  },
  [NODE_TYPES.API_CALL]: { icon: MdApi, color: "#00897b" },
  [NODE_TYPES.PRICING]: { icon: MdEuro, color: COLORS.C_SUCCESS },
  [NODE_TYPES.GENERATE_DOCUMENTS]: { icon: MdDescription, color: "#6d4c41" },
  [NODE_TYPES.SEND_DOCUMENTS]: { icon: MdSend, color: "#5c6bc0" },
  [NODE_TYPES.REQUEST_SIGNATURE]: { icon: MdDraw, color: "#8e24aa" },
  [NODE_TYPES.AWAIT_SIGNATURE]: { icon: MdHourglassEmpty, color: "#9c27b0" },
  [NODE_TYPES.SETUP_PAYMENT]: { icon: MdPayment, color: "#2e7d32" },
  [NODE_TYPES.PUSH_TO_MANAGEMENT]: { icon: MdBusinessCenter, color: "#455a64" },
  [NODE_TYPES.AWAIT_MANAGEMENT_ACK]: {
    icon: MdHourglassEmpty,
    color: "#607d8b",
  },
  [NODE_TYPES.REQUEST_TERMINATION]: { icon: MdOutlineCancel, color: "#e53935" },
  [NODE_TYPES.AWAIT_TERMINATION_ACK]: {
    icon: MdHourglassEmpty,
    color: "#ef5350",
  },
  [NODE_TYPES.COMMISSION]: { icon: MdPercent, color: "#fb8c00" },
  [NODE_TYPES.FORK]: { icon: MdCallSplit, color: "#546e7a", diamond: true },
  [NODE_TYPES.JOIN]: { icon: MdCallMerge, color: "#546e7a", diamond: true },
  [NODE_TYPES.TIMER]: { icon: MdTimer, color: "#fbc02d" },
  [NODE_TYPES.NOTIFICATION]: { icon: MdNotifications, color: "#1e88e5" },
  [NODE_TYPES.ASSIGN]: { icon: MdPersonAdd, color: "#00acc1" },
};

export const nodeTypeMeta = (nodeType) =>
  NODE_TYPE_META[nodeType] ||
  NODE_TYPE_META[NODE_TYPES.STATUS] || {
    icon: MdAccountTree,
    color: COLORS.C_PRIMARY,
  };

export const NODE_TYPE_VALUES = [
  NODE_TYPES.STATUS,
  NODE_TYPES.FORM_STEP,
  NODE_TYPES.DECISION,
  NODE_TYPES.FORK,
  NODE_TYPES.JOIN,
  NODE_TYPES.TIMER,
  NODE_TYPES.AWAIT_SIGNATURE,
  NODE_TYPES.AWAIT_MANAGEMENT_ACK,
  NODE_TYPES.AWAIT_TERMINATION_ACK,
];
